export enum EnumPagTipo {
    AMBOS = 0,
    PAGAR = 1,
    RECEBER = 2,
}